// import axios from 'axios';
import axiosInstance from './axiosInstance';
import axios from 'axios';
import { OK_STATUS_CODE } from './constants';
import { sortTypeMapper } from '../utils/sorting';
import fileUploadApi from './fileUploadInstance';
import { APP_MASTER_TYPES, APP_USER_TYPES } from '../appContants';
// Uncomment the following line if you're using API_BASE_URL
const API_BASE_URL =
  'https://jf8gh0609g.execute-api.us-east-1.amazonaws.com/dev';

const apiService = {
  // Users
  async getUserProfile() {
    try {
      const response = await axiosInstance.get('/clinic/user/profile');
      return response?.data?.data; // Return only the data, not the entire response object
    } catch (error) {
      return undefined;
    }
  },
  async updateUserProfile(data) {
    const response = await axiosInstance.put('/clinic/user/profile', data);
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
    return response;
  },
  async getAllUsers(associationType = APP_USER_TYPES.clinicUser) {
    try {
      const response = await axiosInstance.get(
        // TODO: remove static limit
        // handle through input search (paginated list)
        '/clinic/user/staff?limit=100&page=1',
        {
          params: {
            associationType,
          },
        }
      );
      return response?.data?.data; // Return only the data, not the entire response object
    } catch (error) {
      console.log('Error fetching users:', error); // Log the specific error message
      return;
    }
  },
  async getAllUsersCaseAccess() {
    try {
      const response = await axiosInstance.get(
        // TODO: remove static limit
        // handle through input search (paginated list)
        '/clinic/user/staff/names-with-case-access'
      );
      return response?.data?.data; // Return only the data, not the entire response object
    } catch (error) {
      console.log('Error fetching users:', error); // Log the specific error message
      return;
    }
  },
  async inviteUser(data) {
    try {
      const response = await axiosInstance.post(
        '/clinic/user/invitation',
        data
      );
      return response; // Return only the data, not the entire response object
    } catch (error) {
      console.log('Error :', error); // Log the specific error message
      return false;
    }
  },
  async deleteUserInvite(invitationId) {
    const response = await axiosInstance.delete(
      `/clinic/user/invitation/${invitationId}`
    );
    return response;
  },
  async updateStaff(data) {
    const response = await axiosInstance.put('/clinic/user/staff', data);
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
    return response;
  },
  async userList(params, associationtype = APP_USER_TYPES.clinicUser) {
    try {
      const response = await axiosInstance.get('/clinic/user/staff', {
        params: {
          associationtype,
          limit: params.limit,
          page: params.page,
          clinicId: params.clinicId,
          search: params.search,
          sortBy: params.sortBy,
          sortOrder: sortTypeMapper(params.sortOrder),
        },
      });
      return response?.data?.data; // Return only the data, not the entire response object
    } catch (error) {
      console.log('Error fetching users:', error); // Log the specific error message
      return false;
    }
  },
  async invitedUser(id) {
    try {
      const res = await axios.get(
        `${API_BASE_URL}/clinic/user/invitation/${id}`
      );
      return res;
    } catch (error) {
      return false;
    }
  },
  // Auth
  async signUPClinic(cognitoUser) {
    try {
      const res = await axiosInstance.post('/clinic/auth/signup', cognitoUser);
      return res; // Return only the data, not the entire response object
    } catch (error) {
      console.log('Error :', error); // Log the specific error message
      return false;
    }
  },
  async signUPUser(cognitoUser) {
    try {
      const res = await axios.post(
        `${API_BASE_URL}/clinic/auth/user-signup`,
        cognitoUser
      );
      return res; // Return only the data, not the entire response object
    } catch (error) {
      console.log('Error :', error); // Log the specific error message
      throw error;
    }
  },
  async confirmSignupClinic(cognitoUser) {
    try {
      const res = await axios.post(
        `${API_BASE_URL}/clinic/auth/signup-confirmation`,
        cognitoUser
      );
      return res; // Return only the data, not the entire response object
    } catch (error) {
      console.log('Error :', error); // Log the specific error message
      return false;
    }
  },
  async getUserStatus(email) {
    const response = await axiosInstance.post('/clinic/auth/user-status', {
      email,
    });
    return response?.data?.data || response?.data;
  },
  async callme() {
    try {
      const response = await axiosInstance.get('/clinic/auth/me');
      return response; // Return only the data, not the entire response object
    } catch (error) {
      // Preserve the error response for proper error handling
      if (error?.response?.data) {
        const apiError = new Error(error.response.data?.error || error.response.data?.message || 'Error fetching user');
        apiError.response = error.response;
        throw apiError;
      }
      throw error;
    }
  },
  // Branches
  async branchList(params) {
    try {
      const response = await axiosInstance.get('/clinic/locations', {
        params: {
          limit: params.limit,
          page: params.page,
          clinicId: params.clinicId,
          search: params.search,
          sortBy: params.sortBy,
          sortOrder: sortTypeMapper(params.sortOrder),
        },
      });
      return response?.data?.data;
    } catch (error) {
      return [];
    }
  },
  async createBranch(data, params) {
    const response = await axiosInstance.post(`/clinic/locations/`, data, {
      params,
    });
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
    return response;
  },
  async updateBranch(id, data, params) {
    const response = await axiosInstance.put(`/clinic/locations/${id}`, data, {
      params,
    });
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
    return response;
  },
  async updateClinicLocationPaymentMethod(id, data, params) {
    const response = await axiosInstance.put(`/clinic/locations/${id}/payment-method`, data, {
      params,
    });
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
    return response;
  },
  // Cases
  async caseList(params) {
    try {
      const response = await axiosInstance.get('/clinic/cases', {
        params: {
          limit: params.limit,
          page: params.page,
          search: params.search,
          sortBy: params.sortBy,
          sortOrder: sortTypeMapper(params.sortOrder),
          caseStatus: params.caseStatus,
          hasRush: params.hasRush,
        },
      });
      return response?.data?.data;
    } catch (error) {
      return [];
    }
  },
  async getCase(id) {
    try {
      const response = await axiosInstance.get(`/clinic/cases/${id}`);
      return response?.data?.data;
    } catch (error) {
      return;
    }
  },
  async getCaseReport(id, caseReportId) {
    try {
      const response = await axiosInstance.get(
        `/clinic/cases/${id}/download-report`,
        {
          params: {
            caseReportId,
          },
        }
      );
      return response?.data?.data;
    } catch (error) {
      return;
    }
  },
  async getCaseFile(id, objectKey, fileName) {
    try {
      const response = await axiosInstance.get(`/clinic/cases/${id}/files`, {
        params: { objectKey, fileName },
      });
      return response?.data?.data;
    } catch (error) {
      return;
    }
  },
  async getPresignedUrl(payload) {
    const response = await axiosInstance.post('/clinic/cases/files', payload);
    const presigned = response?.data?.data;
    if (!presigned) {
      throw new Error('Failed to get upload URL');
    }
    return presigned;
  },
  async getPresignedForProfileUrl(data) {
    const response = await axiosInstance.post(
      `/clinic/user/profile/photo`,
      data
    );
    return response?.data?.data;
  },
  async uploadWithPresignedUrl(url, data, onProgress) {
    return await fileUploadApi.post(url, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: ({ total, loaded }) => {
        onProgress?.({ percent: Math.round((loaded / total) * 100) });
      },
    });
  },
  async createCase(data, params) {
    const response = await axiosInstance.post('/clinic/cases/', data, {
      params,
    });
    if (response?.status === OK_STATUS_CODE) {
      return response?.data;
    }
    return response;
  },
  async updateCase(id, data, params) {
    const response = await axiosInstance.put(`/clinic/cases/${id}`, data, {
      params,
    });
    if (response?.status === OK_STATUS_CODE) {
      return response?.data;
    }
    return response;
  },
  async markCaseAsSubmitted(id) {
    const response = await axiosInstance.patch(`/clinic/cases/${id}/submit`);
    if (response?.status === OK_STATUS_CODE) {
      return response?.data;
    }
    return response;
  },
  async deleteCase(id) {
    const response = await axiosInstance.delete(`/clinic/cases/${id}`);
    if (response?.status === OK_STATUS_CODE) {
      return response?.data;
    }
    return response;
  },
  // Payment Transactions
  async getCaseTransactionStatus(id) {
    const response = await axiosInstance.get(
      `/clinic/payment-transactions/can-make-payment/case`,
      {
        params: {
          caseId: id,
        },
      }
    );
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
    return response;
  },
  async getInvoiceTransactionStatus(id) {
    const response = await axiosInstance.get(
      `/clinic/payment-transactions/can-make-payment/invoice`,
      {
        params: {
          invoiceId: id,
        },
      }
    );
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
    return response;
  },
  /**
   *
   * @param {*} data Expects the case ID
   * @returns
   */
  async paymentTransactionCreateOrder(data) {
    const response = await axiosInstance.post(
      '/clinic/payment-transactions/order',
      data
    );
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
    return response;
  },
  /**
   *
   * @param {*} data Expects Order ID
   * @returns
   */
  async paymentTransactionCompleteOrder(data) {
    const response = await axiosInstance.put(
      '/clinic/payment-transactions/order',
      data
    );
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
    return response;
  },
  /**
   *
   * @param {*} data Expects Order ID
   * @returns
   */
  async paymentTransactionCanceOrder(data) {
    const response = await axiosInstance.put(
      '/clinic/payment-transactions/order/cancel',
      data
    );
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
    return response;
  },
  // Case Services
  async servicesList() {
    try {
      const response = await axiosInstance.get('/clinic/masters', {
        params: {
          masterType: APP_MASTER_TYPES.service,
        },
      });
      return response?.data?.data;
    } catch (error) {
      return;
    }
  },
  // Invoice master
  async getAllInvoices(params) {
    try {
      const response = await axiosInstance.get('/clinic/invoices', {
        params: {
          limit: params.limit,
          page: params.page,
          search: params.search,
          sortBy: params.sortBy,
          sortOrder: sortTypeMapper(params.sortOrder),
          status:params.status === "paid"? true: params.status === "unpaid"? false:null
        },
      });
      return response?.data?.data; // Return only the data, not the entire response object
    } catch (error) {
      console.log('Error fetching invoice list:', error); // Log the specific error message
      return;
    }
  },
  async downloadInvoicePreview(invoiceId) {
    const response = await axiosInstance.get(
      `${'/clinic/invoices'}/${invoiceId}/download`
    );
    if (response?.status === OK_STATUS_CODE) {
      return response?.data?.data;
    }
  },
  async getDashboard() {
    try {
      const response = await axiosInstance.get('/clinic/cases/dashboard');
      return response?.data?.data; // Return only the data, not the entire response object
    } catch (error) {
      console.log('Error fetching dashboard list:', error); // Log the specific error message
      return;
    }
  },
  async verifyCaptchaToken(captchaValue) {
    const response = await axios.post(
      `${API_BASE_URL}/clinic/auth/verify-recaptcha-scores`,
      {
        captchaValue,
      }
    );
    return response?.data?.data;
  },
  // Add more API functions as needed
};

export default apiService;
